"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportsController = function ReportsController($rootScope, $scope, User, AuthenticationService, FunctionService, $cookieStore, V2Service, CONST) {
  _classCallCheck(this, ReportsController);

  this.appFunctions = [];
  this.name = "reports";
  this.user = User.getUser();

  // Subscribe to functions fetched event then populate side menu lists
  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
    // $scope.vm.appFunctions = response.functions.filter(x => x.functionType === 'REP');
    $scope.vm.appFunctions = response.functions.filter(function (func) {
      return func.functionType === "REP";
    }).sort(function (repFuncA, repFuncB) {
      return repFuncA.name.localeCompare(repFuncB.name);
    });
  });

  $scope.navItemClick = function (route, toggleMenu) {
    $rootScope.globals = $cookieStore.get("globals");
    var roleId = $rootScope.globals.currentUser.roleId ? $rootScope.globals.currentUser.roleId : $scope.vm.userRoleId;

    // If on login page assume logged out so clear function settings
    if (route.indexOf($scope.vm.loginRoute) > -1) {
      $scope.vm.appFunctionSettings = {};
      $scope.vm.appFunctions = [];
    }

    // Close nav menu when left hand menu item clicked
    if (toggleMenu) {
      var d = document.querySelector(".mdl-layout");
      d.MaterialLayout.toggleDrawer();
    }

    if (route.indexOf("v2") > -1) {
      $rootScope.stopTokenRefresh = true;
      var cfDomain = ".codefocus.com.au";
      var cfDomainIndex = window.location.hostname.indexOf(cfDomain) || window.location.hostname.indexOf("10.0.1.1");

      $rootScope.globals.currentUser.redirectRoute = route.replace("" + V2CONTEXT + "/", "");

      AuthenticationService.SetCredentials($scope.vm.user.codingOperationsTeam, $scope.vm.user.email, $scope.vm.user.name, $scope.vm.user.specialty, $scope.vm.user.role, $scope.vm.user.worklist, $scope.vm.user.id, $scope.vm.user.token, roleId, $rootScope.globals.currentUser.redirectRoute, $rootScope.globals.currentUser.activeDirectoryToken, $rootScope.globals.currentUser.initialLogin, $scope.vm.user.campus);

      if (window.location.hostname.indexOf("localhost") > -1) {
        if (roleId) {
          window.location = "http://localhost:4200/" + V2CONTEXT + "?token=" + $rootScope.globals.currentUser.token + "&roleId=" + roleId + "&redirectRoute=" + $rootScope.globals.currentUser.redirectRoute;
        }
      } else if (cfDomainIndex) {
        V2Service.redirectToV2(roleId);
      }
    }
  };
};

exports.default = ReportsController;


// WEBPACK FOOTER //
// ./client/app/components/reports/reports.controller.js